angular.module('gym.components').directive('reportUserFilter', function() {
  return {
    restrict: 'E',
    template: require('templates/components/reports/report_user_filter.html.slim')
  };
});
